// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","502":"component---src-pages-ierr-2025-index-js"}[chunkId] + "-" + {"125":"b9ceceac47e47d9d1f49","293":"78eb9afafdaff6c454e4","502":"0485e71ce76828a9499d"}[chunkId] + ".js";
};